import React from 'react'
import WarningPanel from './panel/WarningPanel'
import PrimaryButton from './buttons/PrimaryButton'
import PrimaryLink from './buttons/PrimaryLink'
import { FormattedMessage } from 'react-intl'
import {
  useTransfer,
  STATUS_ACCEPTED,
  STATUS_REJECTED,
} from '../../commons/useTransfer'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import { always } from 'ramda'

// to do
const useStyles = makeStyles((theme) => ({
  cancelLink: {
    padding: '6px 16px',
    fontWeight: 'bold',
    marginTop: '1px',
    textTransform: 'uppercase',
  },
}))
export default ({ firstName, lastName, transferRequestId, type }) => {
  const name = `${firstName} ${lastName}`
  const { createStatusButton } = useTransfer()
  const classes = useStyles()

  const [acceptLoading, accept] = createStatusButton(
    transferRequestId,
    STATUS_ACCEPTED,
  )
  const [cancelLoading, cancel] = createStatusButton(
    transferRequestId,
    STATUS_REJECTED,
  )

  const acceptTransfer = () => {
    accept()
  }

  const contentId =
    type === 1 ? 'transfer.panel.content' : 'transfer.panel.content.members'

  return (
    <WarningPanel>
      <div className="flex justify-between items-center">
        <span>
          <FormattedMessage
            id={contentId}
            values={{
              teamMemberName: name,
            }}
          />
        </span>
        <div className="flex items-center">
          <PrimaryLink
            onClick={cancelLoading ? always() : cancel}
            className={clsx(classes.cancelLink, 'ltr:mr-3 rtl:ml-3')}
          >
            <FormattedMessage id="action.decline" />
          </PrimaryLink>
          <PrimaryButton
            isLoading={acceptLoading}
            labelId={'action.accept'}
            onClick={acceptTransfer}
          />
        </div>
      </div>
    </WarningPanel>
  )
}
